import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react'; // Import Components

import { FooterView } from './FooterView'; // Styled Components via Emotion

var FooterWrapper = _styled("footer", {
  target: "eem3k9x0",
  label: "FooterWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "zyjvv0",
  styles: "height:100%;width:100%;*{box-sizing:content-box !important;}"
} : {
  name: "zyjvv0",
  styles: "height:100%;width:100%;*{box-sizing:content-box !important;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Gb290ZXIvaW5kZXguanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9tQyIsImZpbGUiOiIuLi8uLi9zcmMvRm9vdGVyL2luZGV4LmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG4vLyBJbXBvcnQgQ29tcG9uZW50c1xuaW1wb3J0IHsgRm9vdGVyVmlldyB9IGZyb20gJy4vRm9vdGVyVmlldydcblxuLy8gU3R5bGVkIENvbXBvbmVudHMgdmlhIEVtb3Rpb25cbmNvbnN0IEZvb3RlcldyYXBwZXIgPSBzdHlsZWQuZm9vdGVyYFxuXHRoZWlnaHQ6IDEwMCU7XG5cdHdpZHRoOiAxMDAlO1xuXG5cdCoge1xuXHRcdGJveC1zaXppbmc6IGNvbnRlbnQtYm94ICFpbXBvcnRhbnQ7XG5cdH1cbmBcblxuLyoqXG4gKiBUaGlzIENvbXBvbmVudCBpcyB0aGUgRm9vdGVyXG4gKiBUaGlzIGlzIGdsb2JhbCwgYW5kIG5vdCBkeW5hbWljXG4gKiBUYWtlcyBpbiB0aGUgRm9vdGVyVmlldyBjb21wb25lbnQgc28gd2UgY2FuIHBhc3MgdGhlIHRoZW1lIHByb3BzXG4gKiBPbiBEZXNrdG9wOiBhbGwgdGhlIGxpbmtzIHNob3VsZCBiZSBsYWlkIG91dFxuICogT24gTW9iaWxlOiBhbGwgdGhlIGxpbmtzIGFyZSBncm91cGVkIHVwIGludG8gZHJhd2Vyc1xuICovXG5leHBvcnQgZnVuY3Rpb24gRm9vdGVyKCkge1xuXHRyZXR1cm4gKFxuXHRcdDxGb290ZXJXcmFwcGVyIGlkPVwiZm9vdGVyXCI+XG5cdFx0XHQ8Rm9vdGVyVmlldyAvPlxuXHRcdDwvRm9vdGVyV3JhcHBlcj5cblx0KVxufVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
/**
 * This Component is the Footer
 * This is global, and not dynamic
 * Takes in the FooterView component so we can pass the theme props
 * On Desktop: all the links should be laid out
 * On Mobile: all the links are grouped up into drawers
 */


export function Footer() {
  return /*#__PURE__*/React.createElement(FooterWrapper, {
    id: "footer"
  }, /*#__PURE__*/React.createElement(FooterView, null));
}